import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function Billing({ firmId, firmName, userEmail }) {
  const seatCount = parseInt(new URLSearchParams(window.location.search).get('seats'), 10) || 1;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubscribe = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/api/stripe/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ firmId, firmName, email: userEmail, quantity: seatCount }),
      });

      const data = await response.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        setError('Failed to start checkout. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
      <h2>2ndCounsel Subscription</h2>
      <p>{seatCount} seat{seatCount !== 1 ? 's' : ''} &mdash; $299/seat/month &mdash; cancel anytime.</p>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button
        onClick={handleSubscribe}
        disabled={loading}
        style={{
          backgroundColor: '#4f46e5',
          color: 'white',
          padding: '12px 24px',
          border: 'none',
          borderRadius: '6px',
          fontSize: '16px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
        }}
      >
        {loading ? 'Redirecting...' : 'Subscribe Now'}
      </button>
    </div>
  );
}
